import React, { useCallback, useEffect, useRef, useState } from "react";
import { throttle } from "lodash";
import { UI } from "@wwimmo/ui";
import "./Colorpicker.css";

interface ColorpickerProps {
    value: string;
    onChange: (color: string) => void;
    height?: number;
}

export const Colorpicker = (props: ColorpickerProps) => {
    const [color, setColor] = useState<string>(props.value);

    useEffect(() => {
        setColor(props.value);
    }, [props.value]);

    const colorChange = (newColor: string) => {
        props.onChange(newColor);
    };

    const delayedColorChange = useRef(throttle((c: string) => colorChange(c), 200)).current;

    const onChangeColorpicker = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const newColor = event.target.value;
            setColor(newColor);
            delayedColorChange(newColor);
        },
        [delayedColorChange]
    );

    return (
        <div className="Colorpicker">
            <input
                className="ColorpickerInput w-100 h-100"
                type="color"
                value={color}
                onChange={onChangeColorpicker}
            />
            <div className="Overlay" style={{ ["--colorpicker-color" as any]: color }}>
                <UI.Icon icon={UI.SVGIcon.Edit} color="white" />
            </div>
        </div>
    );
};
